import { reactive } from 'vue';

function useResetableState<TState extends object>(defaultState: TState | (() => TState)) {
  const state = reactive<TState>({ ...getInitialState() });

  function resetState() {
    Object.assign(state, getInitialState());
  }

  function getInitialState() {
    return typeof defaultState === 'function' ? defaultState() : defaultState; 
  }

  return { state, resetState };
}

export default useResetableState;